import { Box, Column, Columns, Control, Field, Input } from "@allxsmith/bestax-bulma";
import React from "react";

export default function Customer({ contact, handleChange, handleCheckbox }) {
  return (
    <Box>
      <h1 className="title">Customer Details</h1>
      <Columns isMultiline>
        <Column>
          <Field>
            <label className="label label">Labour Markup (%)</label>
            <Control>
              <Input
                type="number"
                name="labour_rate_markup"
                onChange={handleChange}
                value={String(contact.labour_rate_markup)}
                required
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label label">Parts Markup (%)</label>
            <Control>
              <Input
                type="number"
                name="parts_markup"
                onChange={handleChange}
                value={String(contact.parts_markup)}
                required
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Weekly Rentals Target</label>
            <Control>
              <Input
                type="number"
                name="weekly_target"
                onChange={handleChange}
                value={String(contact.weekly_target)}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Display Cost Summary on Jobs Page</label>
            <input
              className="checkbox"
              type="checkbox"
              name="display_job_cost_summary"
              onChange={handleCheckbox}
              checked={contact.display_job_cost_summary}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Internal Account</label>
            <input
              className="checkbox"
              type="checkbox"
              name="internal_account"
              onChange={handleCheckbox}
              checked={contact.internal_account}
            />
          </Field>
        </Column>
      </Columns>
    </Box>
  );
}
